
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function FAQ() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿La IA toma decisiones por el equipo clínico?',
      answer: 'No. PreBedAI es una herramienta de apoyo a la decisión. La IA analiza datos históricos del hospital y sugiere prioridades (predicción de altas, asignación de camas), pero el equipo clínico siempre valida y decide. Todas las sugerencias son transparentes y editables. El criterio profesional prevalece en todo momento.'
    },
    {
      question: '¿Cuánto tiempo lleva implementar PreBedAI?',
      answer: 'La implementación básica puede completarse en 2-4 semanas. Esto incluye: configuración de plantas y camas, formación del equipo, integración con sistemas existentes (si aplica) y periodo de pruebas. El tiempo exacto depende del tamaño del centro y la complejidad de la integración con HIS/ERP.'
    },
    {
      question: '¿Necesitamos formación especial para usar PreBedAI?',
      answer: 'No se requiere formación técnica avanzada. PreBedAI está diseñado para ser intuitivo y fácil de usar desde el primer día. Ofrecemos sesiones de onboarding (1-2 horas) para cada rol y materiales de apoyo (tutoriales en vídeo, guías rápidas). La mayoría de los equipos se sienten cómodos en menos de una semana.'
    },
    {
      question: '¿Funciona en móvil y tablet?',
      answer: 'Sí, PreBedAI es 100% responsive y funciona en cualquier dispositivo: ordenador, tablet o smartphone. El equipo pertinente puede recibir notificaciones y confirmar tareas desde sus móviles. La interfaz se adapta automáticamente al tamaño de pantalla.'
    },
    {
      question: '¿Qué pasa con nuestros datos? ¿Son seguros?',
      answer: 'Sí. PreBedAI cumple con GDPR y normativas de protección de datos sanitarios. Todos los datos están cifrados (en tránsito y en reposo) y almacenados en servidores seguros en la Unión Europea. Solo el personal autorizado de tu hospital tiene acceso a la información.'
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-[#0A1628] mb-4 sm:mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            Preguntas Frecuentes
          </h2>
          <p className="text-base sm:text-xl text-gray-600 px-2">
            Resolvemos las dudas más comunes sobre PreBedAI
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg sm:rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 sm:px-8 py-4 sm:py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-sm sm:text-lg font-bold text-[#0A1628] pr-3 sm:pr-4">
                  {faq.question}
                </h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl sm:text-2xl text-[#6D28D9] flex-shrink-0`}></i>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-4 sm:px-8 pb-4 sm:pb-6">
                  <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-8 sm:mt-12 text-center">
          <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
            ¿Tienes más preguntas?
          </p>
          <button 
            onClick={() => {
              if (isHomePage) {
                const el = document.getElementById('final-cta');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              } else {
                navigate('/', { state: { scrollTo: 'final-cta' } });
              }
            }}
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-[#6D28D9] text-white rounded-lg font-semibold hover:bg-[#8B5CF6] transition-all duration-300 hover:-translate-y-1 hover:shadow-xl cursor-pointer whitespace-nowrap text-sm sm:text-base"
          >
            <span>Contacta con nosotros</span>
            <i className="ri-mail-send-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
